import { render } from "./CustomerRegisterWaitPage.vue?vue&type=template&id=3d842098&scoped=true"
import script from "./CustomerRegisterWaitPage.vue?vue&type=script&lang=js"
export * from "./CustomerRegisterWaitPage.vue?vue&type=script&lang=js"

import "./CustomerRegisterWaitPage.vue?vue&type=style&index=0&id=3d842098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d842098"]])

export default __exports__